/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         30/04/24 - 09:54:30
 * Module name:  headers-groups-table.const
 * File name:    headers-groups-table.const.ts
 * IDE:          WebStorm
 */


import {
  TableColumnAlignEnum,
  TableColumnEnum,
  TableColumnInterface,
  TableIconEnum,
} from '@shared/components/table';
/**
 * @description
 * Header array for contracts table
 */
export const CONTRACT_MAIN_HEADERS: TableColumnInterface[] = [
  {
    field: 'contract_number',
    type: TableColumnEnum.text,
    header: 'app.setting.contract.fields.internalCode.label',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'customer_number',
    type: TableColumnEnum.text,
    header: 'app.setting.contract.fields.code.label',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'contract_at',
    type: TableColumnEnum.text,
    header: 'app.setting.contract.fields.duration.header',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'auto_end',
    type: TableColumnEnum.iconDual,
    header: 'app.setting.contract.fields.autoEnd.label',
    align: TableColumnAlignEnum.center,
    dualIcon: [TableIconEnum.circleCheck, TableIconEnum.circleClose]
  },
  {
    field: 'is_perpetual',
    type: TableColumnEnum.iconDual,
    header: 'app.setting.contract.fields.perpetual.label',
    align: TableColumnAlignEnum.center,
    grow: .5,
    dualIcon: [TableIconEnum.circleCheck, TableIconEnum.circleClose]
  },
  {
    field: 'enabled',
    type: TableColumnEnum.tag,
    header: 'app.setting.contract.fields.enable.header',
    align: TableColumnAlignEnum.center,
    grow: .5
  }
];
/**
 * @description
 * Header child array for contracts table
 */
export const CONTRACT_CHILD_HEADERS: TableColumnInterface[] = [
  {
    field: 'description',
    type: TableColumnEnum.text,
    header: 'app.setting.contract.list.children.columns.name',
    align: TableColumnAlignEnum.center
  },
  {
    field: 'quantity',
    type: TableColumnEnum.text,
    header: 'app.setting.contract.list.children.columns.quantity',
    align: TableColumnAlignEnum.center
  }
];
